module.exports = __webpack_public_path__ + "static/media/appposts.bea8fe22.png";